<template>
  <div class="page_">
    <div class="up_">
      <div class="left_">
        产品名称：
        <a-input
          v-model="name"
          placeholder="请输入产品名称"
          style="width: 150px; margin-right: 20px"
        ></a-input>
        产品代码：
        <a-input
          v-model="code"
          placeholder="请输入产品代码"
          style="width: 150px; margin-right: 20px"
        ></a-input>
        模板：
        <a-select style="width: 150px; margin-right: 20px" v-model="templateCode" placeholder="请选择模板">
          <a-select-option v-for="item in bjqTypeList" :key="item.code">
            {{item.name}}
          </a-select-option>
        </a-select>
        <a-button @click="fetchList">搜索</a-button>
      </div>
      <a-button type="primary" @click="toAdd"
        ><a-icon type="plus" />新建</a-button
      >
    </div>

    <a-table @change="tableChange" :pagination="pagination" :columns="columns" :data-source="data" bordered>
      <template slot="do" slot-scope="text, record">
        <a-button style="margin-right: 10px" @click="toEdit(record)">
          编辑
        </a-button>
        <a-button @click="toDelete(record)">
          删除
        </a-button>
      </template>
      <template slot="templateCode" slot-scope="text, record">
        {{ text | filterTemp }}
      </template>
      <template slot="status" slot-scope="text">
        {{ text | filterStatus }}
      </template>
    </a-table>
  </div>
</template>

<script>
import api from "@/utils/sdApi";
const bjqTypeList = [
  {
    name: "建工意外险",
    code: "001",
  },
  {
    name: "团体意外险",
    code: "002",
  },
  {
    name: "OPA（海外派遣团体意外险）",
    code: "003",
  },
];
const columns = [
  {
    title: "计算器id",
    dataIndex: "id",
    key: "id",
    scopedSlots: { customRender: "id" },
  },
  {
    title: "产品代码",
    dataIndex: "code",
    key: "code",
    scopedSlots: { customRender: "code" },
  },
  {
    title: "产品名称",
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "所属模板",
    dataIndex: "templateCode",
    key: "templateCode",
    scopedSlots: { customRender: "templateCode" },
  },
  {
    title: "计算器状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
  },
  // {
  //   title: "产品描述",
  //   dataIndex: "productDesc",
  //   key: "productDesc",
  //   scopedSlots: { customRender: "productDesc" },
  // },
  {
    title: "报价书链接",
    dataIndex: "link",
    key: "link",
    scopedSlots: { customRender: "link" },
  },
  {
    title: "操作",
    dataIndex: "do",
    key: "do",
    width: 180,
    scopedSlots: { customRender: "do" },
  },
];

const data = [
  {
    id: 18,
    name: "产品1",
  },
  {
    id: 19,
    name: "产品2",
  },
];
export default {
  data() {
    return {
      pagination: {
        total: 0,
        current:1,
        pageSize: 10
      },
      bjqTypeList,
      data,
      columns,
      name: "",
      code: "",
      templateCode: "",
      uStr:'',
    };
  },
  filters: {
    filterTemp(val) {
      let v = "";
      if (val == "001") {
        v = "建工意外险";
      } else if (val == "002") {
        v = "团体意外险";
      } else if (val == "003") {
        v = "OPA（海外派遣团体意外险）";
      }
      return v;
    },
    filterStatus(val) {
      let v = "";
      if (val == "0") {
        v = "有效";
      } else if (val == "1") {
        v = "无效";
      }
      return v;
    },
  },
  mounted() {
    this.uStr = this.$route.query.uStr
    this.fetchList();
  },
  methods: {
    toAdd() {
      this.$router.push({ name: "Setting",query:{uStr:this.uStr} });
    },
    toEdit(record) {
      this.$router.push({ name: "edit", query:{id: record.id,uStr:this.uStr} });
    },
    toDelete(record) {
      let data = {
        quoteId: record.id,
        uStr: this.uStr
      };
      api.delete(data).then((res) => {
        this.$notification.success({message:'删除成功'})
        this.fetchList();
      });
    },
    tableChange(pagination){
      this.pagination = {...pagination}
      console.log(pagination,"-->")
      this.fetchList()
    },
    fetchList() {
      let data = {
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.name,
        code: this.code,
        templateCode: this.templateCode,
      };
      api.fetchList(data).then((res) => {
        let data = res.data.msg.data
        this.pagination.total = res.data.msg.total
        let arr = []
        let origin = window.location.origin
        data.map(item=>{
          let url = origin + "/pcmall/BJQ/mindex?id=" + item.id + '&uStr='+this.uStr;
          arr.push({
            ...item,
            link: url
          })
        })
        this.data = arr;
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.page_ {
  padding: 30px;
  padding-bottom: 100px;
  width: 80%;
  margin: 0 auto;
  .up_ {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
  }
}
</style>
